// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Link from "./components/Link/Link.bs.js";
import * as Theme from "./styles/Theme.bs.js";
import * as NavBar from "./components/NavBar/NavBar.bs.js";
import * as Router from "./Router.bs.js";
import * as Emotion from "./bindings/Emotion.bs.js";
import * as RelayEnv from "./relay/RelayEnv.bs.js";
import * as Typography from "./components/Typography/Typography.bs.js";
import * as AuthContext from "./context/AuthContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptRelayReact from "rescript-relay/src/RescriptRelayReact.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

Emotion.Css.injectGlobal(`
#root {
  width: 100%;
  min-height: 100vh;
}
`);

function App$AppShell(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let match = url.path;
  let isJournal = match !== 0 ? match.hd === "journal" : false;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(NavBar.NavBar.make, {}),
      JsxRuntime.jsx("main", {
        children: JsxRuntime.jsx(Router.make, {}),
        className: Emotion.Css.css({
          flex: "1",
          display: "flex",
          flexDirection: "column"
        })
      }),
      isJournal ? null : JsxRuntime.jsxs("footer", {
          children: [
            JsxRuntime.jsx("div", {
              children: [
                "/about",
                "/posts",
                "/components"
              ].map(path => {
                let label;
                switch (path) {
                  case "/about" :
                    label = "About";
                    break;
                  case "/posts" :
                    label = "Posts";
                    break;
                  default:
                    label = "Components";
                }
                return JsxRuntime.jsx(Link.Link.make, {
                  href: path,
                  variant: "subtle",
                  children: label
                }, path);
              }),
              className: Emotion.Css.css({
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "1.25rem",
                marginBottom: "0.75rem"
              })
            }),
            JsxRuntime.jsx(Typography.Typography.Caption.make, {
              children: "The Journal"
            })
          ],
          className: Emotion.Css.css({
            padding: "2rem 1rem",
            textAlign: "center",
            maxWidth: "680px",
            margin: "0 auto",
            width: "100%",
            borderTop: `1px solid ` + Theme.Theme.Colors.border.default
          })
        })
    ],
    className: Emotion.Css.css({
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh"
    })
  });
}

let AppShell = {
  make: App$AppShell
};

function App$App(props) {
  return JsxRuntime.jsx(AuthContext.Provider.make, {
    children: JsxRuntime.jsx(RescriptRelayReact.Context.Provider.make, {
      environment: RelayEnv.environment,
      children: JsxRuntime.jsx(App$AppShell, {})
    })
  });
}

let App = {
  make: App$App
};

export {
  AppShell,
  App,
}
/*  Not a pure module */
